// Belgische werkdagen tussen twee tijdstippen — de enige maat voor wachttijd en
// doorlooptijd in de Helpdesk (04-10-2026).
// Een werkdag is maandag t/m vrijdag die geen Belgische wettelijke feestdag is
// (Nieuwjaar, Paasmaandag, 1 mei, O.L.H. Hemelvaart, Pinkstermaandag, 21 juli,
// 15 augustus, 1 november, 11 november, Kerstmis): op die dagen kan niemand een
// ticket behandelen. Brugdagen en regionale feestdagen tellen als werkdag.
// Backend-tegenhanger: backend/src/util/werkdagen.js — hou de twee gelijk.
//
// Telling: het aantal werkdagen vanaf de startdag tot (niet met) de einddag.
// Een ticket van vandaag telt 0, van gisteren (werkdag) 1, van vrijdag op
// maandag 1 (het weekend telt niet mee).

// Paaszondag (gregoriaans) als lokale datum.
function pasen(jaar) {
  const a = jaar % 19, b = Math.floor(jaar / 100), c = jaar % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  return new Date(jaar, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
}
const sleutel = (d) => d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
const perJaar = new Map();
function feestdagenVan(jaar) {
  if (!perJaar.has(jaar)) {
    const p = pasen(jaar);
    const na = (dagen) => sleutel(new Date(p.getFullYear(), p.getMonth(), p.getDate() + dagen));
    perJaar.set(jaar, new Set([jaar * 10000 + 101, na(1), jaar * 10000 + 501, na(39), na(50), jaar * 10000 + 721, jaar * 10000 + 815, jaar * 10000 + 1101, jaar * 10000 + 1111, jaar * 10000 + 1225]));
  }
  return perJaar.get(jaar);
}
export const isFeestdag = (d) => feestdagenVan(d.getFullYear()).has(sleutel(d));
export const isWerkdag = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !isFeestdag(d);

const dagStart = (ms) => { const d = new Date(ms); d.setHours(0, 0, 0, 0); return d; };

export function werkdagenTussen(vanMs, totMs = Date.now()) {
  if (!Number.isFinite(vanMs) || !Number.isFinite(totMs) || totMs <= vanMs) return 0;
  let cur = dagStart(vanMs);
  const eind = dagStart(totMs);
  let n = 0;
  while (cur < eind) {
    if (isWerkdag(cur)) n += 1;
    cur = new Date(cur.getFullYear(), cur.getMonth(), cur.getDate() + 1);
  }
  return n;
}

// Wachttijd-categorieën voor niet-afgehandelde tickets: < 2, 2–5, 5–10, ≥ 10
// werkdagen. Grenzen zijn ondergrens-inclusief: precies 5 werkdagen valt in "5–10".
export const WERKDAG_BUCKETS = [
  { key: 'wd0', label: '< 2 werkdagen', van: 0, tot: 2 },
  { key: 'wd2', label: '2 – 5 werkdagen', van: 2, tot: 5 },
  { key: 'wd5', label: '5 – 10 werkdagen', van: 5, tot: 10 },
  { key: 'wd10', label: '> 10 werkdagen', van: 10, tot: Infinity },
];

export function werkdagBucket(werkdagen) {
  if (werkdagen == null || !Number.isFinite(werkdagen)) return null;
  const b = WERKDAG_BUCKETS.find((x) => werkdagen >= x.van && werkdagen < x.tot);
  return b ? b.key : null;
}
